import React, { Fragment } from 'react'
import { useCallback, useMemo } from 'sb-hooks'
import { useConnect } from 'sb-redux-hook'
import { constants, getMainPageLink } from 'common/helpers'
import actions from 'redux/actions'

import ModalContainer from 'components/_new/modal/ModalContainer/ModalContainer'
import DialogModal from 'components/_new/modal/DialogModal/DialogModal'
import Overlay from 'components/_new/layout/Overlay/Overlay'

import messages from './messages'


const close = () => actions.models.modals.close(constants.modals.humble.FlashSaleExpired)

const FlashSaleExpiredModal = () => {
  const { mainPageLink, pathname } = useConnect({
    mainPageLink: (state) => getMainPageLink({ state }),
    pathname: 'routing.location.pathname',
  })

  const onClick = useCallback(() => {
    actions.models.router.push(mainPageLink)
    close()
  }, [ mainPageLink ])

  const buttonProps = useMemo(() => (
    pathname === mainPageLink
      ? { title: messages.gotIt, onClick: close }
      : { title: messages.backToMainPage, onClick }
  ), [ pathname, mainPageLink, onClick ])

  return (
    <Fragment>
      <ModalContainer>
        <Overlay onClick={close} />
        <DialogModal
          title={messages.title}
          text={messages.text}
          leftButton={buttonProps}
          onClose={close}
        />
      </ModalContainer>
    </Fragment>
  )
}


export default FlashSaleExpiredModal
